import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../forms/button/button.module';
import { SimpleModalComponent } from './simple-modal.component';

@NgModule({
  declarations: [SimpleModalComponent],
  imports: [CommonModule, ButtonModule],
  exports: [SimpleModalComponent]
})
export class SimpleModalModule {}
